// import actions
import cajaAction from './actions/caja'
import gastoAction from './actions/gasto'
import liquidacionAction from './actions/liquidacion'
// import getters

// import mutations

// import states

const actions = { ...cajaAction, ...gastoAction, ...liquidacionAction }

const getters = { }

const mutations = { }

const state = { }

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
}
